import { defineSlotRecipe } from "@chakra-ui/react/styled-system";
import { popoverAnatomy } from "@chakra-ui/react/anatomy";

export default defineSlotRecipe({
  slots: popoverAnatomy.keys(),
  base: {
    content: {
      overflow: "hidden",
    },
  },
});
